export const Categories = [
  { id: 1, name: "Phones", image: "/category-images/phones.png" },
  { id: 2, name: "Computers", image: "/category-images/electronics.png" },
  { id: 3, name: "Fashion", image: "/category-images/fashion.png" },
  { id: 4, name: "Home & Furniture", image: "/category-images/furniture.png" },
  { id: 5, name: "Vehicles", image: "/category-images/vehicles.png" },
  { id: 6, name: "Beauty", image: "/category-images/beauty.png" },
  { id: 7, name: "Gaming", image: "https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?w=500&q=80" },
  { id: 8, name: "Kids", image: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=500&q=80" },
  { id: 9, name: "Sports", image: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=500&q=80" },
  { id: 10, name: "Pets", image: "https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=500&q=80" },
  { id: 11, name: "Services", image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&q=80" },
];
